// extracted by mini-css-extract-plugin
export default {"aCard":"assessmentcard_aCard__PsVHw"};